import { Slider as MuiSlider, SliderProps } from '@mui/material';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export default function Slider(props: SliderProps) {
  return <StyledSlider {...props} />;
}

const StyledSlider = styled(MuiSlider)<{ disabled?: boolean }>(({ disabled }) => ({
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: COLORS.primary,
    '&.Mui-disabled': {
      backgroundColor: COLORS.grey250,
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
    height: 4,
    borderRadius: '100px',
    backgroundColor: disabled ? COLORS.grey250 : COLORS.primary,
  },
  '& .MuiSlider-rail': {
    opacity: 0.38,
    backgroundColor: COLORS.grey200,
  },
}));
